import { useEffect, useState } from 'react'
import { Link, useNavigate, useOutletContext } from 'react-router-dom'

import { createElement } from '../../../api/elements.js'
import { listGroupConfigs } from '../../../api/groupConfigs.js'

export default function ElementCreatePage() {
  const { applicationId } = useOutletContext()
  const navigate = useNavigate()

  const [groupConfigs, setGroupConfigs] = useState([])
  const [values, setValues] = useState({
    name: '',
    groupConfigId: '',
    elementType: 'advertising',
    jsonConfig: '',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    listGroupConfigs(applicationId)
      .then((list) => {
        if (!cancelled) setGroupConfigs(list || [])
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [applicationId])

  function onChange(field) {
    return (e) => setValues((prev) => ({ ...prev, [field]: e.target.value }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (isSubmitting) return
    setError(null)

    const name = String(values.name || '').trim()
    if (!name) {
      setError(new Error('Name is required'))
      return
    }
    const groupConfigId = values.groupConfigId != null && values.groupConfigId !== '' ? values.groupConfigId : null
    if (!groupConfigId) {
      setError(new Error('Group config is required'))
      return
    }

    setIsSubmitting(true)
    try {
      const created = await createElement(applicationId, {
        ...values,
        rawJsonConfig: values.jsonConfig,
        status: 'draft',
      })
      navigate(`/applications/${applicationId}/elements/${created.id}`)
    } catch (err) {
      const detail = err?.body?.detail
      const message = Array.isArray(detail)
        ? detail.map((d) => d.msg ?? d).join(', ')
        : typeof detail === 'string'
          ? detail
          : err?.message ?? String(err)
      setError(new Error(message))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="page">
      <div className="pageHeader">
        <h1 className="pageTitle">Create element</h1>
        <Link to={`/applications/${applicationId}/elements`} className="button buttonGhost">
          Back to elements
        </Link>
      </div>

      <section className="card formCard">
        <div className="cardTitle">Element</div>
        <form className="formGrid" onSubmit={handleSubmit}>
          <label className="formField">
            <span className="formLabel">Name</span>
            <input className="textInput" value={values.name} onChange={onChange('name')} />
          </label>

          <label className="formField">
            <span className="formLabel">Group config</span>
            <select className="textInput" value={String(values.groupConfigId || '')} onChange={onChange('groupConfigId')} required>
              <option value="">Choose group config</option>
              {groupConfigs.map((gc) => (
                <option key={gc.id} value={String(gc.id)}>
                  {gc.name || `Group #${gc.id}`}
                </option>
              ))}
            </select>
          </label>

          <label className="formField">
            <span className="formLabel">Type</span>
            <select className="textInput" value={values.elementType} onChange={onChange('elementType')}>
              <option value="advertising">advertising</option>
              <option value="inapp">inapp</option>
              <option value="balance">balance</option>
            </select>
          </label>

          <label className="formField">
            <span className="formLabel">JSON config</span>
            <textarea
              className="textInput textAreaMonoLg"
              value={values.jsonConfig}
              onChange={onChange('jsonConfig')}
              placeholder='{"key":"value"}'
            />
          </label>

          <div className="formActions">
            <button type="submit" className="button buttonPrimary" disabled={isSubmitting}>
              {isSubmitting ? 'Creating…' : 'Create'}
            </button>
          </div>
        </form>

        {error ? <div className="formError">{String(error?.message || error)}</div> : null}
      </section>
    </div>
  )
}

